module.exports = __webpack_public_path__ + "img/cancle.98ab0f6.svg";